<div mat-dialog-title class="dialog-header aum-typo-headline-3">
    <div class="dialog-title">
        <span class="title-span"> {{ 'aumico_reports_company_valuation_dialog_title' | i18next }}</span>
    </div>
    <div class="seprator"></div>
    <div class="close-dialog">
        <mat-dialog-actions>
            <mat-icon (click)="closeDialog()" svgIcon="interface-delete 1"></mat-icon>
        </mat-dialog-actions>
    </div>
</div>
<div mat-dialog-content>
    <div>
        <mat-icon svgIcon="aumico-pattern-icon-task-check"></mat-icon>
    </div>
    <div>
        <span class="dialog-text-content-title">{{
            'aumico_reports_company_valuation_confirmation_dialog_content_title' | i18next
        }}</span>
    </div>
    <div class="dialog-text-content">
        <span>
            <!--Content-->
            {{ 'aumico_reports_company_valuation_confirmation_dialog_text' | i18next }}
        </span>
    </div>
</div>
<div class="actions-footer">
    <mat-dialog-actions>
        <button aum-button (click)="closeDialog()" color="blue">
            {{ 'aumico_reports_company_valuation_confirmation_dialog_button_text' | i18next }}
        </button>
    </mat-dialog-actions>
</div>
